import { Empty as _Empty } from "@okee-uikit/react/es/components/empty";
import React, { useMemo } from 'react';
import { useLocale } from '@okee-uikit/react-config';
import { useTableRows } from '../row-data/row-info';
import { useTableCep } from '../implements/implement';
import { useTableColumnsWidth } from '../implements/size';
export function TableEmpty() {
  var _useTableRows = useTableRows(),
      emptyText = _useTableRows.emptyText,
      renderEmpty = _useTableRows.renderEmpty,
      current = _useTableRows.current;

  var _useTableCep = useTableCep(),
      elem = _useTableCep.elem;

  var defaultEmptyText = useLocale('table.emptyText');

  var _useTableColumnsWidth = useTableColumnsWidth(),
      containerInnerWidth = _useTableColumnsWidth.containerInnerWidth;

  var emptyInner = useMemo(function () {
    return React.createElement(_Empty, {
      content: emptyText == null ? defaultEmptyText : emptyText
    });
  }, [defaultEmptyText, emptyText]);
  var emptyContent = renderEmpty && renderEmpty();

  if (emptyContent) {
    emptyInner = React.createElement(_Empty, null, emptyContent);
  }

  return current.length ? null : React.createElement("div", {
    className: elem('Empty'),
    style: {
      width: containerInnerWidth
    }
  }, emptyInner);
}